const tone = (d) =>
  d > 90 ? "bg-red-100 text-red-700 border-red-200"
    : d > 60 ? "bg-orange-100 text-orange-700 border-orange-200"
      : d > 30 ? "bg-amber-100 text-amber-800 border-amber-200"
        : "bg-emerald-50 text-emerald-700 border-emerald-200";

const label = (d) => {
  if (d === 0) return "Bugün borçlandı";
  if (d < 30) return `${d} gündür borçlu`;
  const m = Math.floor(d / 30);
  return `${d} gündür borçlu · ~${m} ay`;
};

export const DebtAgeBadge = ({ days, testId }) => (
  <span data-testid={testId} title="En eski ödenmemiş borcun üzerinden geçen gün"
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold tabular ${tone(days)}`}>
    {label(days)}
  </span>
);
